import React, { useEffect } from 'react'

import { setCSSVariable } from '../../../helpers/setVariable'
import { Footer } from '../../Footer/Footer'
import { Header } from '../../Header/Header'
import { LayoutTypes } from './Layout.types'

export const Layout = ({ children, isWhite, darkTheme }: LayoutTypes) => {
  useEffect(() => {
    if (darkTheme) {
      document.body.classList.add('theme--dark')
      setCSSVariable('--base-black', '#fff')
      setCSSVariable('--base-title-black', '#CCC7C0')
    }

    return () => {
      document.body.classList.remove('theme--dark')
      setCSSVariable('--base-black', '#141414')
      setCSSVariable('--base-title-black', '#141414')
    }
  })

  return (
    <div
      style={{
        background: darkTheme ? '#262423' : 'transparent',
      }}
    >
      <Header isWhite={isWhite} />
      <main>{children}</main>
      <Footer isWhite={darkTheme} />
    </div>
  )
}
